import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

const HonestyPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#f5f9ff',
      100: '#d0e1fd',
      200: '#abc9fb',
      300: '#85b2f9',
      400: '#609af8',
      500: '#3b82f6',
      600: '#326fd1',
      700: '#295bac',
      800: '#204887',
      900: '#183462',
      950: '#102340',
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f9fafb',
          100: '#f3f4f6',
          200: '#e5e7eb',
          300: '#d1d5db',
          400: '#9ca3af',
          500: '#6b7280',
          600: '#4b5563',
          700: '#374151',
          800: '#1f2937',
          900: '#111827',
          950: '#111827',
        },
        focusRing: {
          shadow: '0 0 0 0.2rem #bfdbfe',
        },
        highlight: {
          background: '#eff6ff',
          focusBackground: 'rgba(59, 130, 246, 0.24)',
          color: '#1d4ed8',
          focusColor: '#1d4ed8',
        },
        formField: {
          background: '#ffffff',
          disabledBackground: '#f3f4f6',
          filledBackground: '#f3f4f6',
          filledHoverBackground: '#f3f4f6',
          filledFocusBackground: '#ffffff',
          borderColor: '#d1d5db',
          hoverBorderColor: '#3b82f6',
          focusBorderColor: '#3b82f6',
          invalidBorderColor: '#e24c4c',
          color: '#64748b',
          disabledColor: '#9ca3af',
          placeholderColor: '#94a3b8',
          invalidPlaceholderColor: '#e24c4c',
          iconColor: '#94a3b8',
          shadow: 'none',
        },
        text: {
          color: '#4b5563',
          hoverColor: '#374151',
          mutedColor: '#6b7280',
          hoverMutedColor: '#4b5563',
        },
        content: {
          background: '#ffffff',
          hoverBackground: '#f3f4f6',
          borderColor: '#e5e7eb',
          color: '#4b5563',
          hoverColor: '#4b5563',
        },
        overlay: {
          select: {
            background: '#ffffff',
            borderColor: '#e5e7eb',
            color: '#4b5563',
          },
          popover: {
            background: '#ffffff',
            borderColor: '#e5e7eb',
            color: '#4b5563',
          },
          modal: {
            background: '#ffffff',
            borderColor: '#e5e7eb',
            color: '#4b5563',
          },
        },
        list: {
          option: {
            focusBackground: '#e5e7eb',
            selectedBackground: '#eff6ff',
            selectedFocusBackground: 'rgba(59, 130, 246, 0.24)',
            color: '#4b5563',
            focusColor: '#4b5563',
            selectedColor: '#1d4ed8',
            selectedFocusColor: '#1d4ed8',
            icon: {
              color: '#6b7280',
              focusColor: '#4b5563',
            },
          },
          optionGroup: {
            background: 'transparent',
            color: '#374151',
          },
        },
        navigation: {
          item: {
            focusBackground: '#e5e7eb',
            activeBackground: '#eff6ff',
            color: '#4b5563',
            focusColor: '#4b5563',
            activeColor: '#1d4ed8',
            icon: {
              color: '#6b7280',
              focusColor: '#4b5563',
              activeColor: '#1d4ed8',
            },
          },
          submenuLabel: {
            background: 'transparent',
            color: '#374151',
          },
          submenuIcon: {
            color: '#6b7280',
            focusColor: '#4b5563',
            activeColor: '#1d4ed8',
          },
        },
      },
    },
  },
  components: {
    inputtext: {
      root: {
        color: '#4b5563',
        placeholderColor: '#94a3b8',
      },
      colorScheme: {
        light: {
          root: {
            color: '#4b5563',
            placeholderColor: '#94a3b8',
          },
        },
      },
    },
    select: {
      root: {
        color: '#64748b',
        placeholderColor: '#94a3b8',
      },
      dropdown: {
        color: '#94a3b8',
      },
      colorScheme: {
        light: {
          root: {
            color: '#64748b',
            placeholderColor: '#94a3b8',
          },
          dropdown: {
            color: '#94a3b8',
          },
          overlay: {
            color: '#64748b',
          },
        },
      },
    },
    floatlabel: {
      root: {
        color: '#6b7280',
        activeColor: '#6b7280',
      },
      colorScheme: {
        light: {
          root: {
            color: '#6b7280',
            activeColor: '#6b7280',
          },
        },
      },
    },
    datatable: {
      css: `
        .p-datatable-mask.p-overlay-mask {
          background: transparent;
          pointer-events: none;
        }
      `,
    },
  },
});

export const primeNgTheme = {
  preset: HonestyPreset,
  options: {
    darkModeSelector: 'none',
    cssLayer: {
      name: 'primeng',
      order: 'tailwind-base, primeng, tailwind-utilities',
    },
  },
};
